import { pluralize } from '@cian/newbuilding-utils';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { FC } from 'react';

import { CoworkingProfitBanner } from '../CoworkingProfitBanner';

import { WorkplaceInCoworkingHeaderProps } from './types';

import * as styles from './WorkplaceInCoworkingHeader.css';

export const WorkplaceInCoworkingHeader: FC<WorkplaceInCoworkingHeaderProps> = props => {
  const { price, count, title } = props;

  return (
    <div className={styles['container']}>
      <ArticleHeading2>{title}</ArticleHeading2>
      <div className={styles['cost-container']}>
        <div className={styles['cost']}>
          <ArticleHeading2>{numberToPrettyString(price)} ₽/мес.</ArticleHeading2>
        </div>
        <CoworkingProfitBanner />
      </div>
      <ArticleParagraph1>{`Доступно ${pluralize(count, ['место', 'места', 'мест'])}`}</ArticleParagraph1>
    </div>
  );
};

WorkplaceInCoworkingHeader.displayName = 'WorkplaceInCoworkingHeader';
